import React from 'react';
import {
	FilePreviewContainer,
	PreviewContainer,
	PreviewList,
	FileMetaData,
	RemoveFileIcon,
	ImagePreviewDiv
} from '../images-to-pdf/ImageUpload.styles';
interface UploadedImagesProps {
	files: any;
	removeFile: (fileName: any, index: number) => void;
}
const KILO_BYTES_PER_BYTE = 1000;

// const convertNestedObjectToArray = (nestedObj: any) =>
// 	Object.keys(nestedObj).map((key) => nestedObj[key]);

const convertBytesToKB = (bytes: number) =>
	Math.round(bytes / KILO_BYTES_PER_BYTE);

export const UploadedImages: React.FC<UploadedImagesProps> = ({
	files,
	removeFile
}) => {
	console.log(files);
	return (
		<React.Fragment>
			<h2>Uploaded Images {files.length}</h2>
			<FilePreviewContainer>
				<PreviewList>
					<div className='images-container'>
						{Object.keys(files).map((fileName, index) => {
							let file = files[fileName];
							let isImageFile =
								file.type.split('/')[0] === 'image';
							let imageBlob = URL.createObjectURL(file);
							return (
								<PreviewContainer key={fileName}>
									<div>
										{isImageFile && (
											<ImagePreviewDiv
												image={imageBlob}
											/>
										)}
										<FileMetaData isImageFile={isImageFile}>
											<span>{file.name}</span>
											<aside>
												<span>
													{convertBytesToKB(
														file.size
													)}{' '}
													kb
												</span>
												<RemoveFileIcon
													className='fas fa-trash-alt'
													onClick={() =>
														removeFile(
															fileName,
															index
														)
													}
												/>
											</aside>
										</FileMetaData>
									</div>
								</PreviewContainer>
							);
						})}
					</div>
				</PreviewList>
			</FilePreviewContainer>
		</React.Fragment>
	);
};
